var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41016 22.4082V23.8249C5.41016 24.952 5.85792 26.033 6.65495 26.8301C7.45198 27.6271 8.53299 28.0749 9.66016 28.0749H23.8268C24.954 28.0749 26.035 27.6271 26.832 26.8301C27.6291 26.033 28.0768 24.952 28.0768 23.8249V22.4082M22.4102 16.7415L16.7435 22.4082M16.7435 22.4082L11.0768 16.7415M16.7435 22.4082V5.4082",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.38a06c94f790bbf8295f2073963f484d.svg";
export { ForwardRef as ReactComponent };